import React from 'react';
import { OverlaySpinner } from '@insurancemenu/imenu-components-lib/dist/components';
import { EnrollmentCardType, EnrollmentPeriod } from 'types/enrollmentService';
import { observer } from 'mobx-react-lite';
import EnrollmentCardWrapper from '../EnrollmentCardWrapper';
import { ProposalsCardWrapperStyled, SectionStyled, SectionSubtitleStyled, SectionTitleStyled } from './styles';

interface Props {
  cardsList: EnrollmentPeriod[];
  loading?: boolean;
  sectionTitle?: string;
  sectionSubtitle?: string;
  type?: EnrollmentCardType;
  onContinue?: () => void;
  className?: string;
}

const EnrollmentCardsSection: React.FC<Props> = observer(
  ({ cardsList, loading = false, sectionTitle, sectionSubtitle, type = 'common', className, onContinue }) => {
    return (
      <SectionStyled className={className}>
        {cardsList.length > 0 && sectionTitle && <SectionTitleStyled>{sectionTitle}</SectionTitleStyled>}
        {sectionSubtitle && <SectionSubtitleStyled>{sectionSubtitle}</SectionSubtitleStyled>}
        <ProposalsCardWrapperStyled>
          {loading && type === 'common' && <OverlaySpinner display={loading} />}
          {cardsList.map((enrollmentPeriod) => (
            <EnrollmentCardWrapper
              key={enrollmentPeriod.id}
              enrollmentPeriod={enrollmentPeriod}
              type={type}
              onContinue={onContinue}
            />
          ))}
        </ProposalsCardWrapperStyled>
      </SectionStyled>
    );
  },
);

export default EnrollmentCardsSection;
